var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x88\x8A",
    d: "M6.70932 19.9686L4.09081 20.9732C3.91849 21.0334 3.7649 20.9921 3.63004 20.8491C3.49518 20.7136 3.46522 20.5593 3.54014 20.3863L4.57405 17.8352L16.6776 5.68917L18.8016 7.81133L6.70932 19.9686ZM19.858 6.77283L17.7115 4.63938L18.9028 3.45413C19.195 3.16816 19.4947 3.01766 19.8018 3.0026C20.1165 2.98003 20.4087 3.1042 20.6784 3.37511L21.1167 3.81535C21.3864 4.08626 21.5138 4.37975 21.4988 4.69582C21.4838 5.00436 21.3302 5.30538 21.038 5.59887L19.858 6.77283Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.b40d772eb48f7066d861651c2beb8677.svg";
export { ForwardRef as ReactComponent };